/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { IMenuItem } from '../interfaces/menuItem';
import { Router } from '@angular/router';
import { IMenuProvider } from '../interfaces/menuProvider';
import { MenuItemBase } from './menuItemBase';

/**
 * The structure for the Items of a menu
 * @class MenuItem
 */
export class DefaultMenuItem extends MenuItemBase{
    constructor(public id:number,public text:string = "",public action:string = "",public childs: Array<IMenuItem> = [], public parent:IMenuItem = null){
        super(id,text,action,childs,parent);
    }

}